/* ROUGHCUT builds reel.
   ES5 only — Shopify's asset minifier on this theme targets es5 and refuses
   const/arrow/template syntax, then silently serves the file unminified.

   The whole job is: play exactly one video, keep two more ready, and hold
   nothing else in memory. Thirty reels at 5MB is 150MB, and a phone that
   tries to hold that will simply stop. */
(function () {
  var root = document.getElementById('rcReels');
  if (!root) return;
  var feed = document.getElementById('rrFeed');
  if (!feed) return;

  var reels = [].slice.call(feed.querySelectorAll('.rr-reel'));
  if (!reels.length) return;

  var cue = document.getElementById('rrCue');
  var title = document.getElementById('rrTitle');
  /* reels = every reel, in shuffled order and never re-ordered again.
     view  = the ones the filter is currently letting through. Every index
     from here down — current, the window, the observer, the arrow keys —
     is an index into VIEW, not into reels. Getting that wrong is how you
     end up preloading three videos nobody can reach. */
  var view = [];
  var muted = true;          /* browsers only autoplay muted; see below */
  var current = -1;
  var WINDOW = 1;            /* how many reels either side stay loaded */

  /* ── order ────────────────────────────────────────────────────────────
     Liquid has no shuffle, so it happens here. Pinned reels keep their
     editor order at the front; everything else is Fisher–Yates. Reordering
     the DOM rather than an array keeps scroll-snap and the observer honest. */
  (function shuffle() {
    var pinned = [], rest = [], i, j, t;
    for (i = 0; i < reels.length; i++) {
      (reels[i].getAttribute('data-pin') === '1' ? pinned : rest).push(reels[i]);
    }
    for (i = rest.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      t = rest[i]; rest[i] = rest[j]; rest[j] = t;
    }
    var order = pinned.concat(rest);
    for (i = 0; i < order.length; i++) feed.appendChild(order[i]);
    reels = order;
    view = order.slice();
  })();

  /* ── sources ──────────────────────────────────────────────────────────
     Shopify transcodes an upload into several renditions plus an m3u8. We
     pick rather than using {{ video_tag }}, which drops the HLS source the
     moment loop is on — and a reel is nothing but a loop.

     Preference: HLS where the browser can play it natively (Safari/iOS,
     where it adapts to a weak signal), otherwise the smallest mp4 that is
     still tall enough for the screen. Shipping a 1080p file to a 390px
     phone is the most common way these end up unwatchable on mobile. */
  function pickSource(list) {
    var i, s, hls = null, mp4 = [];
    for (i = 0; i < list.length; i++) {
      s = list[i];
      if (!s || !s.url) continue;
      if ((s.mime || '').indexOf('mpegurl') > -1) hls = s;
      else if ((s.mime || '').indexOf('mp4') > -1) mp4.push(s);
    }
    var v = document.createElement('video');
    if (hls && v.canPlayType('application/vnd.apple.mpegurl')) return hls.url;
    if (!mp4.length) return hls ? hls.url : null;
    mp4.sort(function (a, b) { return (a.height || 0) - (b.height || 0); });
    var want = (window.innerHeight || 800) * (window.devicePixelRatio || 1);
    for (i = 0; i < mp4.length; i++) if ((mp4[i].height || 0) >= want * 0.75) return mp4[i].url;
    return mp4[mp4.length - 1].url;
  }

  function sourcesFor(reel) {
    var tag = reel.querySelector('.rr-src');
    if (!tag) return [];
    try { return JSON.parse(tag.textContent || '[]'); } catch (e) { return []; }
  }

  function attach(reel) {
    var v = reel.querySelector('.rr-video');
    if (!v || v.getAttribute('data-ready')) return;
    var url = pickSource(sourcesFor(reel));
    if (!url) return;
    v.setAttribute('data-ready', '1');
    v.preload = 'auto';
    v.src = url;
    v.load();
  }

  /* Detaching matters more than attaching. A <video> with a src holds its
     buffer even when paused and off screen; removing the src is what
     actually gives the memory back. */
  function detach(reel) {
    var v = reel.querySelector('.rr-video');
    if (!v || !v.getAttribute('data-ready')) return;
    try { v.pause(); } catch (e) {}
    v.removeAttribute('data-ready');
    v.removeAttribute('src');
    v.load();
    reel.className = reel.className.replace(/ ?rr-(paused|load)\b/g, '');
  }

  function setWindow(idx) {
    var i;
    for (i = 0; i < reels.length; i++) reels[i].rrKeep = false;
    for (i = idx - WINDOW; i <= idx + WINDOW; i++) {
      if (view[i]) view[i].rrKeep = true;
    }
    for (i = 0; i < reels.length; i++) {
      if (reels[i].rrKeep) attach(reels[i]);
      else detach(reels[i]);
    }
  }

  /* ── play control ─────────────────────────────────────────────────────
     Exactly one video is ever playing. play() returns a promise that
     rejects if the browser refuses — usually because something upstream
     unmuted it — so we catch, fall back to muted, and try once more rather
     than leaving a dead frame on screen. */
  function play(reel) {
    var v = reel.querySelector('.rr-video');
    if (!v) return;
    v.muted = muted;
    var p = v.play();
    if (p && p.catch) {
      p.catch(function () {
        v.muted = true;
        muted = true;
        root.className = root.className.replace(/ ?rr-unmuted\b/g, '');
        var q = v.play();
        if (q && q.catch) q.catch(function () {});
      });
    }
  }

  function show(idx) {
    if (idx === current || idx < 0 || idx >= view.length) return;
    if (current > -1 && view[current]) {
      var old = view[current].querySelector('.rr-video');
      if (old) { try { old.pause(); old.currentTime = 0; } catch (e) {} }
      view[current].className = view[current].className.replace(/ ?rr-paused\b/g, '');
    }
    current = idx;
    setWindow(idx);
    play(view[idx]);
    if (cue && idx > 0) cue.className = 'rr-cue rr-gone';
    if (title && idx > 0) title.className = 'rr-title rr-gone';
  }

  /* ── which reel is on screen ──
     0.6 rather than 0.5: at exactly half, two reels can satisfy the
     threshold on the same frame and the feed flickers between them. */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          var idx = view.indexOf(entries[i].target);
          if (idx > -1) show(idx);
        }
      }
    }, { root: feed, threshold: 0.6 });
    for (var i = 0; i < reels.length; i++) io.observe(reels[i]);
  } else {
    show(0);
  }

  /* ── per-reel wiring ── */
  for (var k = 0; k < reels.length; k++) (function (reel) {
    var v = reel.querySelector('.rr-video');
    var bar = reel.querySelector('.rr-bar i');
    var tap = reel.querySelector('.rr-tapzone');
    var sound = reel.querySelector('.rr-sound');
    var full = reel.querySelector('.rr-full');
    var stage = reel.querySelector('.rr-stage');
    if (!v) return;

    v.addEventListener('waiting', function () {
      if (reel.className.indexOf('rr-load') < 0) reel.className += ' rr-load';
    });
    v.addEventListener('playing', function () {
      reel.className = reel.className.replace(/ ?rr-(load|paused)\b/g, '');
    });
    v.addEventListener('timeupdate', function () {
      if (bar && v.duration) bar.style.width = (v.currentTime / v.duration * 100) + '%';
    });

    if (tap) tap.addEventListener('click', function () {
      if (v.paused) { play(reel); }
      else {
        v.pause();
        if (reel.className.indexOf('rr-paused') < 0) reel.className += ' rr-paused';
      }
    });

    if (sound) sound.addEventListener('click', function (e) {
      e.stopPropagation();
      muted = !muted;
      v.muted = muted;
      root.className = muted
        ? root.className.replace(/ ?rr-unmuted\b/g, '')
        : root.className + ' rr-unmuted';
      /* unmuting counts as a user gesture, so a refused autoplay can retry */
      if (!muted && v.paused) play(reel);
    });

    /* Fullscreen: the video element on iOS (webkitEnterFullscreen is the
       only thing that works there), the stage everywhere else so the HUD
       comes with it. */
    if (full) full.addEventListener('click', function (e) {
      e.stopPropagation();
      var el = stage || v;
      if (v.webkitEnterFullscreen && !document.fullscreenEnabled) { v.webkitEnterFullscreen(); return; }
      if (document.fullscreenElement) { document.exitFullscreen(); return; }
      if (el.requestFullscreen) el.requestFullscreen();
      else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
      else if (v.webkitEnterFullscreen) v.webkitEnterFullscreen();
    });

    /* double-tap anywhere on the video also goes full screen */
    var lastTap = 0;
    if (tap) tap.addEventListener('touchend', function () {
      var now = Date.now();
      if (now - lastTap < 300 && full) full.click();
      lastTap = now;
    });
  })(reels[k]);

  /* ── keyboard, for desktop ── */
  document.addEventListener('keydown', function (e) {
    if (sheetOpen()) {
      if (e.key === 'Escape') closeSheet();
      return;
    }
    if (!view[current]) return;
    var r = feed.getBoundingClientRect();
    if (r.bottom < 0 || r.top > innerHeight) return;   /* feed isn't on screen */
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
      if (view[current + 1]) { view[current + 1].scrollIntoView({ behavior: 'smooth' }); e.preventDefault(); }
    } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
      if (view[current - 1]) { view[current - 1].scrollIntoView({ behavior: 'smooth' }); e.preventDefault(); }
    } else if (e.key === 'm') {
      var s = view[current].querySelector('.rr-sound'); if (s) s.click();
    } else if (e.key === ' ') {
      var t = view[current].querySelector('.rr-tapzone'); if (t) { t.click(); e.preventDefault(); }
    }
  });

  /* Leaving the tab should not leave audio playing behind it. */
  document.addEventListener('visibilitychange', function () {
    if (!view[current]) return;
    var v = view[current].querySelector('.rr-video');
    if (!v) return;
    if (document.hidden) { try { v.pause(); } catch (e) {} }
    else if (view[current].className.indexOf('rr-paused') < 0) play(view[current]);
  });

  /* ── the pattern filter ───────────────────────────────────────────────
     Somebody arriving from the Keystone Denims wants Keystone Denims, not a
     shuffle of everything. Filtering is not a display concern here — a reel
     that is hidden but still in the scroll container leaves a snap point
     with nothing in it, a dead stop mid-feed. So filtered reels are taken
     out with display:none, and `view` is rebuilt so the runtime genuinely
     does not know the others exist. */
  var btn   = document.getElementById('rrFilterBtn');
  var sheet = document.getElementById('rrSheet');
  var label = document.getElementById('rrFilterLabel');
  var buy   = document.getElementById('rrSheetBuy');
  var none  = document.getElementById('rrNone');
  var opts  = sheet ? [].slice.call(sheet.querySelectorAll('.rr-opt')) : [];

  function sheetOpen() { return sheet && !sheet.hidden; }
  function openSheet()  { if (sheet) { sheet.hidden = false; document.body.style.overflow = 'hidden'; } }
  function closeSheet() { if (sheet) { sheet.hidden = true;  document.body.style.overflow = ''; } }

  function applyFilter(handle, opt) {
    var i, r, on;

    /* Free every buffer first. Without this, filtering away from a pattern
       leaves its videos loaded and the memory ceiling arrives three filter
       changes later, looking like a random crash. */
    for (i = 0; i < reels.length; i++) detach(reels[i]);

    view = [];
    for (i = 0; i < reels.length; i++) {
      r = reels[i];
      on = handle === 'all' || r.getAttribute('data-product') === handle;
      if (on) {
        r.className = r.className.replace(/ ?rr-off\b/g, '');
        view.push(r);
      } else if (r.className.indexOf('rr-off') < 0) {
        r.className += ' rr-off';
      }
    }

    for (i = 0; i < opts.length; i++) {
      opts[i].className = opts[i] === opt ? 'rr-opt is-on' : 'rr-opt';
    }

    var name = opt ? opt.querySelector('.rr-opt__txt b').textContent : 'All builds';
    if (label) label.textContent = name;
    root.className = handle === 'all'
      ? root.className.replace(/ ?rr-filtered\b/g, '')
      : (root.className.indexOf('rr-filtered') < 0 ? root.className + ' rr-filtered' : root.className);

    var url = opt ? opt.getAttribute('data-url') : '';
    if (buy) {
      if (url) { buy.href = url; buy.textContent = 'View ' + name + ' \u2192'; buy.hidden = false; }
      else buy.hidden = true;
    }

    if (none) none.hidden = view.length > 0;

    /* Back to the top of the new feed. current is cleared first or show(0)
       would see itself as already showing and return without playing. */
    current = -1;
    feed.scrollTop = 0;
    if (view.length) show(0);
    if (title) title.className = 'rr-title rr-gone';
  }

  /* Walk up from whatever was actually tapped. Half the tap targets in the
     sheet are SVG icons, and an SVG element's .className is an
     SVGAnimatedString, not a string — calling .indexOf on it throws. Read
     the class attribute instead, and never touch .className here. */
  function up(el, attr) {
    while (el && el !== sheet) {
      if (el.getAttribute && el.getAttribute(attr) !== null) return el;
      el = el.parentNode;
    }
    return null;
  }
  function upClass(el, cls) {
    while (el && el !== sheet) {
      var c = el.getAttribute ? (el.getAttribute('class') || '') : '';
      if ((' ' + c + ' ').indexOf(' ' + cls + ' ') > -1) return el;
      el = el.parentNode;
    }
    return null;
  }

  if (btn && sheet) {
    btn.addEventListener('click', openSheet);
    sheet.addEventListener('click', function (e) {
      var opt = upClass(e.target, 'rr-opt');
      if (opt) {
        var h = opt.getAttribute('data-handle');
        applyFilter(h, h === 'all' ? null : opt);
        closeSheet();
        return;
      }
      if (up(e.target, 'data-rr-close')) closeSheet();
    });
  }

  setWindow(0);
  show(0);

  /* Deep link: /pages/builds?pattern=<handle> lands straight in that
     pattern's builds, so a "watch people build this" link from a product
     page arrives already filtered rather than in a shuffle of everything. */
  (function fromUrl() {
    var m = /[?&]pattern=([^&#]+)/.exec(window.location.search);
    if (!m || !opts.length) return;
    var want = decodeURIComponent(m[1]);
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].getAttribute('data-handle') === want) { applyFilter(want, opts[i]); return; }
    }
  })();

  if (cue) setTimeout(function () { cue.className = 'rr-cue rr-gone'; }, 6000);
})();
